import { MainMenuIcon } from '@model-framework/menu';
import { MainMenuBox } from '@model-framework/menu/MenuBox';
import { faPlusSquare } from '@fortawesome/free-solid-svg-icons';

type Props = {
  menuSize: number;
  onClick(): void;
  text: string;
};

/**
 * 付箋のグループ化メニューボタン
 * @param menuSize
 * @param onClick
 * @constructor
 */
export const StickyNodeGroupingMenuButton: React.FC<Props> = ({ menuSize, onClick, text }: Props) => {
  return (
    <>
      <MainMenuBox menuSize={menuSize} isSelected={false} onClick={onClick} text={text} />
      <MainMenuIcon icon={faPlusSquare} menuSize={menuSize} />
    </>
  );
};
